import "../servicesstyle.css";

export default function ServiceDetails({ active }) {
  if (!active) return null;

  return (
    <div className="services-details">
      {/* ✅ LEFT IMAGE */}
      <div className="services-details-images">
        <img src={active.details.image} alt="" />
      </div>

      {/* ✅ RIGHT CONTENT */}
      <div className="services-details-content">
        <h3>{active.details.title}</h3>

        <h4>Overview</h4>
        <p>{active.details.overview}</p>

        <h4>What We Do</h4>
        <p>{active.details.whatWeDo}</p>

        <h4>Our Capabilities</h4>
        <ul>
          {active.details.capabilities.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>

        <h4>Benefits to Your Business</h4>
        <ul>
          {active.details.benefits.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
